import { RootState } from "app/store";
import { ChatCardProps } from "declarations/messages";
import { getTime } from "functions/text";
import { IoPerson } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { setChat } from "reducers/chatReducer";

function ChatCard({ onSelectChat, conversation }: ChatCardProps) {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.user);
  const { chat } = useSelector((state: RootState) => state.chat);
  const isActive = chat?._id === conversation._id;

  const unreadConversation = () => {
    if (user?.role === "Admin") {
      return conversation.unreadCounts?.admin || 0;
    }

    if (user?.role === "Staff") {
      return conversation.unreadCounts?.staff || 0;
    }

    return conversation.unreadCounts?.customer || 0;
  };

  const handleSelectChat = () => {
    onSelectChat && onSelectChat();
    dispatch(setChat(conversation));
  };

  return (
    <button
      type="button"
      className={`${ClassName.container} ${isActive && ClassName.activeContainer}`}
      onClick={handleSelectChat}
      aria-current={isActive ? "true" : undefined}
    >
      <div className={ClassName.imageContainer}>
        <IoPerson size={23} />
      </div>
      <div className={ClassName.content}>
        <div className={ClassName.nameContainer}>
          <span
            className={`${ClassName.name} ${isActive && ClassName.activeName}`}
          >
            {conversation.customer?.name || "Conversation"}
          </span>
          <span className={ClassName.time}>
            {getTime(
              conversation.lastMessage?.timestamp || conversation.updatedAt
            )}
          </span>
        </div>
          <span className={ClassName.message}>
          {conversation.lastMessage?.text || "No messages yet"}
        </span>
      </div>
      {unreadConversation() > 0 && (
        <div className={ClassName.tag}>{unreadConversation()}</div>
      )}
    </button>
  );
}

export default ChatCard;

const ClassName = {
  container:
    "w-full flex gap-3 my-1 cursor-pointer relative rounded-xl px-3 py-3 text-left transition-all duration-150 hover:bg-slate-50 border border-transparent hover:border-slate-200",
  activeContainer:
    "bg-slate-100 border-slate-300 shadow-sm ring-1 ring-slate-200",
  imageContainer:
    "flex flex-shrink-0 items-center justify-center w-11 h-11 rounded-full bg-white text-slate-400 border border-slate-200",
  content: "flex flex-1 flex-col justify-center gap-0.5",
  nameContainer:
    "flex items-center justify-between gap-2 text-[10px] text-slate-400",
  name: "text-[15px] text-slate-800 dark:text-slate-100 font-semibold truncate",
  activeName: "text-slate-950",
  time: "flex-shrink-0",
  message: "text-slate-500 dark:text-slate-400 text-[13px] truncate pr-6 line-clamp-1",
  tag: "flex min-w-[20px] h-[20px] px-1.5 items-center justify-center bg-primary absolute right-3 bottom-3 rounded-full text-white text-[10px] font-bold shadow-sm",
};
